import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores';
import AdminLogin from '../components/admin/AdminLogin';
import AdminDashboard from '../components/admin/AdminDashboard';
import AdminEvents from '../components/admin/AdminEvents';
import AdminPOIs from '../components/admin/AdminPOIs';
import AdminPOIImport from '../components/admin/AdminPOIImport';

export default function AdminPanel() {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    return <AdminLogin />;
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <Routes>
        <Route path="/" element={<AdminDashboard />} />
        <Route path="/events" element={<AdminEvents />} />
        <Route path="/pois" element={<AdminPOIs />} />
        <Route path="/pois/import" element={<AdminPOIImport />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </div>
  );
}
